import { AnyObject } from 'src/types';

export const TYPE_TO_LABEL: AnyObject = {
  inactive: 'INACTIVE',
  invited: 'INVITED'
};
